import * as React from "react";
const SvgPlusSquare = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 6, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7,7h50v50h-50zM16,32h32M32,16v32" }));
export default SvgPlusSquare;
